<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editBuilding.id ? $t('add_building_modal.edit') : $t('add_building_modal.new') }} {{ $t('add_building_modal.building') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="column">
						<div class="field">
							<label class="label">{{ $t('add_building_modal.name_label') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="building.name"
									class="input"
									:placeholder="$t('add_building_modal.name_placeholder')"
								/>
							</div>
						</div>

						<div class="field">
							<label class="label">{{ $t('add_building_modal.description_label') }}</label>
							<div class="control">
								<textarea
									v-model="building.description"
									class="textarea"
									rows="3"
									:placeholder="$t('add_building_modal.description_placeholder')"
								/>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('add_building_modal.save') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editBuilding: Object
	},
	data() {
		return {
			building: {
				name: '',
				description: ''
			},
			isLoading: false
		};
	},
	computed: {
		disableSave() {
			return this.building.name == '';
		}
	},
	methods: {
		save() {
			if (!this.isLoading) {
				this.$emit('save', this.building);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		if (this.editBuilding) {
			Object.assign(this.building, this.editBuilding);
		}
	}
};
</script>
